import { ApolloError, useQuery } from '@apollo/client';

import useCompanyContext from 'common/hooks/useCompanyContext';

import { CompanyCreditCardsQueryDocument } from './companyCreditCardsQuery.gql';

interface CreditCard {
  companyUserId: string;
  creditCardId: string;
}

interface CompanyCreditCardsResult {
  creditCards: CreditCard[];
  loading: boolean;
  error?: ApolloError;
}

export const useCompanyCreditCards = (): CompanyCreditCardsResult => {
  const { companyProfileId } = useCompanyContext();
  const {
    data,
    error: creditCardsError,
    loading: creditCardsLoading,
  } = useQuery(CompanyCreditCardsQueryDocument, {
    variables: {
      companyProfileId: companyProfileId as string,
      skip: !companyProfileId,
    },
  });
  const creditCards = data?.viewer?.company?.creditCards || [];

  return {
    creditCards,
    error: creditCardsError,
    loading: creditCardsLoading,
  };
};
